import apiClient from '../config/api/index'
import { addSubscriptionBillingInfo } from '../queries'

const validateToken = async (tokenId) => await apiClient.mutate({ mutation: addSubscriptionBillingInfo, variables: { tokenId } })

export default validateToken